import React, { Suspense } from 'react';

export const MatchesComponent = React.lazy(() => import('./Matches'));

export const Matches = () => (
  <Suspense fallback={null}>
    <MatchesComponent />
  </Suspense>
);
